import { PencilIcon } from "@heroicons/react/outline";
import Layout from "../../components/Layout/Layout";
import React from "react";
import UserServices from "../../services/UserServices";
import { useEffect } from "react";
import { useState } from "react";
import fire from "./../../utils/Toastr";
import { HollowDotsSpinner } from "react-epic-spinners";
import PreOnboardServices from "../../services/PreObnoard";
import { useNavigate } from "react-router-dom";
import BackButton from "../../components/BackButton";
import Modal from "../../components/Modals/preonboard/modal";


export default function ViewPreonboard() {
  const [users, setUser] = useState([]);
  const [loading, setLoading] = useState(false);
  const [statusUserCheck, setStatusUserCheck] = useState("Activate");

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [nin, setNin] = useState("")
  const [open, setOpen] = useState(false)
  const [open1, setOpen1] = useState(false)
  const [open2, setOpen2] = useState(false)

  const name = new URLSearchParams(window.location.search).get("username");
  const nav = useNavigate();

  const viewDetails = async () => {
    const user = await PreOnboardServices.getAccount(name);
    setUser(user?.data);
  };
  const getAllUsers = async () => {
    const users = await PreOnboardServices.getAllUsers(1, 10, name)
    const user = users?.data.result;
    const nin = user[0].nationalIdentificationNumber
    setNin(nin)
  }
 
  useEffect(() => {
    if (users && users?.customerName) {
      const fullname = users?.customerName.split(" ");
      if (fullname.length >= 2) {
        setFirstName(fullname[0]);
        setLastName(fullname[1]);
      } else if (fullname.length === 1) {
        setFirstName(fullname[0]);
        setLastName(""); // Set last name to empty if not provided
      } else {
        setFirstName("");
        setLastName("");
      }
    } else {
      setFirstName("");
      setLastName("");
    }
  }, [users]);

  useEffect(() => {
    viewDetails();
    getAllUsers();
  }, []);

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("details"));
    if (storedUser) {
      const status = storedUser?.find(n => n.emailAddress === users?.email);

      setStatusUserCheck(status)
    } else {
    }
  }, [users]);

  const data = {
    accountNumber: users?.accountNumber,
    onboardingStatus: "Approve"
  }
  const dataa = {
    accountNumber: users?.accountNumber,
    onboardingStatus: "Reject"
  }
  
  const openModal = () => {
    setOpen(true)
  }
  const openModal1 = () => {
    setOpen1(true)
  }
  const openModal2 = () => {
    setOpen2(true)
  }
  const Accept = async () => {
    const res = await PreOnboardServices.Activate(data);
    if(res.status){
        fire("success", res.data)
        nav("/preonboard")
    }

  }
  const Reject = async () => {
    const res = await PreOnboardServices.Activate(data?.accountNumber);
    if(res.status){
        fire("success", res.data)
        // nav("/preonboard")
    }

  }
  const ReSet = async () => {
    const res = await PreOnboardServices.Reset(dataa);
    if(res.status){
        fire("success", res.data)
        nav("/preonboard")
    }

  }
  return (
    <>
      <Layout pageTag={"admin"} current={"/users"}>
        <React.Fragment>
          <main>
            <div className="py-6">
              <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
                <h1 className="text-2xl font-semibold text-gray-900">
                  User Details
                </h1>
              </div>
             <div className="ml-8 mt-5"> <BackButton /></div>
              <div className="float-right flex items-center gap-2">
                {
                  statusUserCheck?.userPreOnboardingStatus === "AdminInitiated" ? (<>
                   <button onClick={openModal} type="button" className=" btn-primary align-center flex justify-center items-center rounded-md border border-transparent py-2 px-4  text-sm font-medium text-white shadow-sm  sm:w-auto "><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true" className="w-3 mr-1.5"><path stroke-linecap="round" stroke-linejoin="round" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path></svg>Accept</button>
                  <button onClick={openModal1} type="button" className=" bg-red-500 align-center flex justify-center items-center rounded-md border py-2 px-4  text-sm font-medium text-white shadow-sm  sm:w-auto mr-7"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true" className="w-3 mr-1.5"><path stroke-linecap="round" stroke-linejoin="round" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path></svg>Reject</button>
                  </>) : statusUserCheck?.userPreOnboardingStatus === "UserCompleted" ? (<button onClick={openModal2} type="button" className=" bg-red-500 align-center flex justify-center items-center rounded-md border py-2 px-4  text-sm font-medium text-white shadow-sm  sm:w-auto mr-7"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true" className="w-3 mr-1.5"><path stroke-linecap="round" stroke-linejoin="round" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path></svg>Reset</button>) : (<p className="mr-9">Approved</p>) 
                }
             
              </div>
              
            </div>
            <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
              <div className="">
                <div className="px-4 sm:px-6 lg:px-8">
                  <div className="mt-8 flex flex-col">
                    <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                      <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8 bg-zinc-200">
                        <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg bg-white mt-5">
                          <div className="">
                            <div className="inline min-w-full py-2 align-middle md:px-6 lg:px-8 bg-white">
                              {/* form */}
                              <React.Fragment>
                                <form className="px-6">
                                  <div className=" mt-5">
                                    <div className="d-flex flex-col">
                                      <h3>Personal Information</h3>
                                      <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-5 gap-y-12">
                                        <div className="">
                                          <label
                                            htmlFor="firstname"
                                            className="ml-1 block text-sm font-medium text-gray-700"
                                          >
                                            Prefix
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              name="prefix"
                                              value={users?.prefix}
                                              id="prefix"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="">
                                          <label
                                            htmlFor="firstname"
                                            className="ml-1 block text-sm font-medium text-gray-700"
                                          >
                                            First Name
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              name="firstname"
                                              value={firstName}
                                              id="firstnmae"
                                              autocomplete="given-name"
                                              placeholder="Enter your First Name"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="">
                                          <label
                                            htmlFor="firstname"
                                            className="ml-1 block text-sm font-medium text-gray-700"
                                          >
                                            Last Name
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              name="firstname"
                                              value={lastName}
                                              id="firstnmae"
                                              autocomplete="given-name"
                                              placeholder="Enter your First Name"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="">
                                          <label
                                            htmlFor="region"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            National Identification Number (NIN)
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              type="text"
                                              value={nin}

                                              name="NIN"
                                             disabled
                                              id="region"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="">
                                          <label
                                            htmlFor="surname"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Email
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              name="surname"
                                              id="surname"
                                              placeholder="Enter user's last name"
                                              value={users?.email}
                                              autocomplete="given-name"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="">
                                          <label
                                            htmlFor="email"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Phone Number
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="email"
                                              value={users?.phoneNumber}
                                              name="email"
                                              placeholder="Enter user's Phone Number"
                                              id="email"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="">
                                          <label
                                            htmlFor="username"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Address
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              name="username"
                                              id="username"
                                              placeholder="Enter user's username"
                                              value={users?.address}
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>

                                        <div className="">
                                          <label
                                            htmlFor="region"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Location
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              value={users?.location}
                                              name="region"
                                              placeholder="Enter user's region"
                                              id="region"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        {/* <div className="">
                                                                        <label htmlFor="region" className="block text-sm font-medium text-gray-700">
                                                                            LGA
                                                                        </label>
                                                                        <div className="mt-1">
                                                                            <input
                                                                            disabled
                                                                                type="text"
                                                                                value={lga}
                                                                                onChange={(e) => setLga(e.target.value)}
                                                                                name="region"
                                                                                placeholder="Enter user's LGA"
                                                                                id="region"
                                                                                className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />

                                                                        </div>
                                                                    </div> */}
                                        <div className="">
                                          <label
                                            htmlFor="region"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Nationality
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              value={users?.nationality}
                                              name="region"
                                              placeholder="Enter user's Nationality"
                                              id="region"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="">
                                          <label
                                            htmlFor="region"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Country
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              value={users?.country}
                                              name="region"
                                              placeholder="Enter user's Nationality"
                                              id="region"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="">
                                          <label
                                            htmlFor="region"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Gender
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              value={
                                                users?.gender == "M"
                                                  ? "Male"
                                                  : "Female"
                                              }
                                              name="region"
                                              placeholder="Enter user's Gender"
                                              id="region"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="">
                                          <label
                                            htmlFor="firstname"
                                            className="ml-1 block text-sm font-medium text-gray-700"
                                          >
                                            Date of birth
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              name="firstname"
                                              value={users?.dateOfBirth}
                                              id="firstnmae"
                                              autocomplete="given-name"
                                              placeholder="Enter user's date of birth"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        {/* <div className="">
                                                                        <label htmlFor="region" className="block text-sm font-medium text-gray-700">
                                                                            Marital status
                                                                        </label>
                                                                        <div className="mt-1">
                                                                            <input
                                                                            disabled
                                                                                type="text"
                                                                                value={status}
                                                                                onChange={(e) => setStatus(e.target.value)}
                                                                                name="region"
                                                                                placeholder="Enter user's Marital status"
                                                                                id="region"
                                                                                className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />

                                                                        </div>
                                                                    </div> */}
                                      </div>
                                    </div>
                                    <div className="d-flex flex-col mt-12">
                                      <h3>Account Imformation</h3>
                                      <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-5 gap-y-12">
                                        <div className="">
                                          <label
                                            htmlFor="region"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Customer Number
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              value={users?.customerNo}
                                              name="region"
                                              placeholder="Enter user's region"
                                              id="region"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="">
                                          <label
                                            htmlFor="region"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Customer Type
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              value={users?.customerType}
                                              name="region"
                                              placeholder="Enter user's username"
                                              id="region"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="">
                                          <label
                                            htmlFor="region"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Account Number
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              value={users?.accountNumber}
                                              name="region"
                                              placeholder="Enter user's region"
                                              id="region"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="">
                                          <label
                                            htmlFor="region"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Alternative Account Number
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              value={users?.altAcNo}
                                              name="region"
                                              placeholder="Enter user's username"
                                              id="region"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="">
                                          <label
                                            htmlFor="region"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            BVN
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              value={users?.bvnNumber}
                                              name="region"
                                              placeholder="Enter user's region"
                                              id="region"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="">
                                          <label
                                            htmlFor="region"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Account Type
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              value={users?.accountType}
                                              name="region"
                                              placeholder="Enter user's region"
                                              id="region"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="">
                                          <label
                                            htmlFor="region"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Account Class
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              value={
                                                users?.accountClassDescription
                                              }
                                              name="region"
                                              placeholder="Enter user's region"
                                              id="region"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="">
                                          <label
                                            htmlFor="region"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Alternative Class Code
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              value={users?.accountClassCode}
                                              name="region"
                                              placeholder="Enter user's username"
                                              id="region"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="">
                                          <label
                                            htmlFor="region"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Customer Category
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              value={users?.customerCategory}
                                              name="region"
                                              placeholder="Enter user's Nationality"
                                              id="region"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="">
                                          <label
                                            htmlFor="region"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Branch Name
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              value={users?.branchName}
                                              name="region"
                                              placeholder="Enter user's region"
                                              id="region"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="">
                                          <label
                                            htmlFor="region"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Available Balance
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              value={users?.availableBalance}
                                              name="region"
                                              placeholder="Enter user's username"
                                              id="region"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="">
                                          <label
                                            htmlFor="region"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Blocked Amount
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              value={users?.blockedAmount}
                                              name="region"
                                              placeholder="Enter user's username"
                                              id="region"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="">
                                          <label
                                            htmlFor="region"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Book Balance
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              value={users?.bookBalance}
                                              name="region"
                                              placeholder="Enter user's username"
                                              id="region"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="">
                                          <label
                                            htmlFor="region"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Currency Code
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              value={users?.ccyCode}
                                              name="region"
                                              placeholder="Enter user's username"
                                              id="region"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="">
                                          <label
                                            htmlFor="region"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Currency
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              value={users?.ccyName}
                                              name="region"
                                              placeholder="Enter user's username"
                                              id="region"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>

                                        <div className="">
                                          <label
                                            htmlFor="region"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Default Media
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              value={users?.defaultMedia}
                                              name="region"
                                              placeholder="Enter user's region"
                                              id="region"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="">
                                          <label
                                            htmlFor="region"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Introducer MISCODE
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              value={users?.introducerMis}
                                              name="region"
                                              placeholder="Enter user's introducer's mis"
                                              id="region"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="">
                                          <label
                                            htmlFor="region"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Joint Account Indicator
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              value={users?.jointAcIndicator}
                                              name="region"
                                              placeholder="Enter user's region"
                                              id="region"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="">
                                          <label
                                            htmlFor="region"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Mandate Authority
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              value={users?.mandateAuthority}
                                              name="region"
                                              placeholder="Enter user's region"
                                              id="region"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="">
                                          <label
                                            htmlFor="region"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Minor
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              value={
                                                users?.minor ? "True" : "False"
                                              }
                                              name="region"
                                              placeholder="Enter user's region"
                                              id="region"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="">
                                          <label
                                            htmlFor="region"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Relationship Manager's Name
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              value={
                                                users?.relationshipManagerName
                                              }
                                              name="region"
                                              placeholder="Enter user's relationship manager's name"
                                              id="region"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="">
                                          <label
                                            htmlFor="region"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Relationship Manager's Code
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              value={
                                                users?.relationshipManagerCode
                                              }
                                              name="region"
                                              placeholder="Enter user's relationship manager's code"
                                              id="region"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div className="">
                                          <label
                                            htmlFor="region"
                                            className="block text-sm font-medium text-gray-700"
                                          >
                                            Signatories
                                          </label>
                                          <div className="mt-1">
                                            <input
                                              disabled
                                              type="text"
                                              value={users?.signatory}
                                              name="region"
                                              placeholder="Enter user's signatory"
                                              id="region"
                                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                          </div>
                                        </div>
                                        <div class=''>
                                          <label htmlFor="region"
                                            className="block text-sm font-medium text-gray-700">Fremium Activated</label>
                                          <input
                                              disabled
                                              type="text"
                                              value={statusUserCheck?.isFreemium == true ? "true" : "false"}
                                              name="region"
                                              
                                              id="region"
                                              className="shadow-sm mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                            />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </form>
                              </React.Fragment>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {open && <Modal textField="you want to activate this user?" open={open} setOpen={setOpen} action={Accept} />}
            {open1 && <Modal textField="you want to reject this user?" open={open1} setOpen={setOpen1} action={Reject} />}
            {open2 && <Modal textField="you want to Reset this user?" open={open2} setOpen={setOpen2} action={ReSet} />}
          </main>
        </React.Fragment>
      </Layout>
    </>
  );
}
